import {
  BasicButton,
  BasicInput,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import TableContainer from "Common/TableContainer";
import { getDefaultValueForSelect } from "helpers/functionsHelpers";
import { Plus } from "lucide-react";
import { useDetailsTransferForm } from "../hooks/useDetailsTransferForm";

export const DetailTransferForm = () => {
  const {
    // * Properties
    t,
    formikDetails: formik,
    columns,
    productRows,
    productOptions,

    // * Methods
  } = useDetailsTransferForm();

  return (
    <>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
        }}
      >
        <div className="flex w-full items-center justify-end flex-wrap">
          <BasicButton
            onClick={() => {}}
            type="submit"
            variant="secondaryOutline"
          >
            <div className="flex flex-row justify-center items-center">
              <Plus size={16} />
              <span className="ml-2">
                {t("transferBetweenWarehouse.addProduct")}
              </span>
            </div>
          </BasicButton>
        </div>
        <div className="grid grid-cols-1 min-[768px]:grid-cols-2 gap-4">
          <div className=" col-span-1 w-full min-[768px]:">
            <SelectComponent
              label={t(
                "transferBetweenWarehouse.detailsTransfer.selectLabelProduct"
              )}
              placeholder={t(
                "transferBetweenWarehouse.detailsTransfer.selectPlaceholderProduct"
              )}
              options={productOptions}
              id="product"
              isMulti={false}
              value={getDefaultValueForSelect(
                productOptions,
                formik.values.product
              )}
              onChange={(option: OptionSelect) => {
                if (option && option.value) {
                  formik.setFieldValue("product", option.value);
                }
              }}
              onBlur={formik.handleBlur}
              isError={formik.touched.product && Boolean(formik.errors.product)}
              errorMessage={formik.errors.product || ""}
            />
          </div>
          <div className=" col-span-1 w-full min-[768px]:">
            <BasicInput
              id="quantity"
              label={t(
                "transferBetweenWarehouse.detailsTransfer.labelQuantity"
              )}
              placeholder={t(
                "transferBetweenWarehouse.detailsTransfer.placeholderQuantity"
              )}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  formik.setFieldValue("quantity", value);
                } 
              }}
              type="number"
              value={formik.values.quantity}
              isError={
                (formik.touched.quantity && Boolean(formik.errors.quantity)) ||
                false
              }
              errorMessage={formik.errors.quantity || ""}
              className="w-full h-20"
            ></BasicInput>
          </div>
          <div className=" col-span-1 w-full min-[768px]:col-span-2">
            <TableContainer
              isPagination={true}
              columns={columns}
              data={productRows}
              isTfoot={false}
              isSelect={true}
              isGlobalFilter={true}
              divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
              tableclassName="display stripe group dataTable w-full text-sm align-middle whitespace-nowrap"
              theadclassName="border-b border-slate-200 dark:border-zink-500"
              thclassName="ltr:!text-left rtl:!text-right p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500 sorting_asc"
              tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
              PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
            ></TableContainer>
          </div>
        </div>
      </form>
    </>
  );
};
